import { useAuth0 } from '@auth0/auth0-react';

export const useAuthService = () => {
  const {
    loginWithRedirect,
    user,
    isAuthenticated,
    isLoading,
    getAccessTokenSilently
  } = useAuth0();

  const authParams = {
    scope: 'openid profile email offline_access',
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  };

  const login = async () => {
    await loginWithRedirect({
      authorizationParams: authParams,
    });
  };

  const getToken = async () => {
    try {
      const token = await getAccessTokenSilently({
        authorizationParams: authParams,
        detailedResponse: true
      });
      return token;
    } catch (error: any) {
      const isLoggingOut = sessionStorage.getItem('is_logging_out') === 'true';

      // Only redirect to login if we're not already in the process of logging in
      // and we're not on the login page
      if ((error.error === 'login_required' || error.error === 'missing_refresh_token') &&
        !isLoading &&
        window.location.pathname !== '/login' &&
        !isLoggingOut) {
        // Clear any existing tokens before redirecting
        localStorage.removeItem('auth0.is.authenticated');
        // Add a flag to prevent infinite redirects
        sessionStorage.setItem('auth_redirect_in_progress', 'true');
        await loginWithRedirect({
          authorizationParams: authParams,
        });
      }
      throw error;
    }
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    getToken
  };
};
